const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  daysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  daysMin = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
  months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

const util = {
  getFormattedDateOrMonth(intDate) {
    if (intDate && intDate > 999999) {
      return this.integerToDate(intDate);
    }
    return this.integerToMonth(intDate);
  },

  integerToMonth(intMonth) {
    if (intMonth) {
      intMonth = intMonth.toString();
      if (intMonth.indexOf("-") == -1) {
        intMonth =
          monthsShort[parseInt(intMonth.substring(4, 6)) - 1] +
          " " +
          intMonth.substring(0, 4);
      }
    }
    return intMonth;
  },

  integerToDate(date) {
    if (date != null && date != undefined) {
      date = date.toString();
      if (date.indexOf("-") == -1) {
        date =
          date.substring(0, 4) +
          "-" +
          date.substring(4, 6) +
          "-" +
          date.substring(6, 8);
      }
    }
    return date;
  },
};

export const RevenueHelper = util;
